import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss']
})
export class UserManagementComponent {
selectedMenu: 'user' | 'role' = 'user';

  constructor(private dialog: MatDialog) {}

  onClose() {
    this.dialog.closeAll();
  }

  updateSelectedMenu(menu: 'user' | 'role') {
    this.selectedMenu = menu;
  }
}
